import { render, staticRenderFns } from "./ukeyRecipientInfo.vue?vue&type=template&id=134eba4f&scoped=true"
import script from "./ukeyRecipientInfo.vue?vue&type=script&lang=js"
export * from "./ukeyRecipientInfo.vue?vue&type=script&lang=js"
import style0 from "./ukeyRecipientInfo.vue?vue&type=style&index=0&id=134eba4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134eba4f",
  null
  
)

export default component.exports